import { Flex, IconButton } from "@chakra-ui/react";
import { FiCopy, FiCheck } from "react-icons/fi";
import { useState } from "react";

// HTML을 일반 텍스트로 변환하는 함수
const htmlToText = (html: string): string => {
  // 임시 DOM 요소 생성
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;

  // HTML 태그 제거하고 텍스트만 추출
  return tempDiv.textContent || tempDiv.innerText || "";
};

interface MessageActionsProps {
  messageId: string;
  content: string;
  onCopy?: (content: string) => void;
  isUserMessage?: boolean;
}

export default function MessageActions({
  content,
  onCopy,
  isUserMessage = false,
}: MessageActionsProps) {
  const [copied, setCopied] = useState(false);

  // 사용자 메시지에는 액션 버튼을 표시하지 않음
  if (isUserMessage) {
    return null;
  }

  const handleCopy = async () => {
    try {
      // HTML을 일반 텍스트로 변환
      const plainText = htmlToText(content);
      await navigator.clipboard.writeText(plainText);
      setCopied(true);
      onCopy?.(plainText);

      // 2초 후 복사 상태 초기화
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy text: ", err);
    }
  };

  return (
    <Flex
      justify="flex-end"
      align="center"
      gap={1}
      mt={2}
      pt={2}
      borderTop="1px solid"
      borderColor="gray.100"
    >
      <IconButton
        aria-label={copied ? "복사됨!" : "복사하기"}
        size="sm"
        variant="ghost"
        colorScheme={copied ? "green" : "gray"}
        onClick={handleCopy}
        _hover={{ bg: "gray.100" }}
      >
        {copied ? <FiCheck /> : <FiCopy />}
      </IconButton>
    </Flex>
  );
}
